import {
  PimProductV1StockStatusEnum,
  type PimProductWithVariantsV1,
} from '@redteclab/api/clients/bully'

const notForSaleVariantStockStatusSet = new Set<PimProductV1StockStatusEnum>([
  PimProductV1StockStatusEnum.NotInCatalog,
  PimProductV1StockStatusEnum.OutOfSale,
  PimProductV1StockStatusEnum.OutOfStock,
])

export const productAccessorVariantsNotForSale = (
  product: PimProductWithVariantsV1,
): boolean => {
  return product.variants.every(
    (variant) =>
      variant.stock_status !== undefined &&
      notForSaleVariantStockStatusSet.has(variant.stock_status),
  )
}
